import { observer } from 'src/utils/mobx-react';
import React, { ChangeEvent } from 'react';
import { LiabilitiesFiltersProps } from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesFilters/LiabilitiesFilters.types';
import { GenericComponentWrapper } from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesFilters/components/GenericComponentWrapper';

type SearchFilterProps = Pick<LiabilitiesFiltersProps, 'onChange'> & {
    query?: string | null;
};

export const SearchFilter = observer(
    'SearchFilter',
    ({ query, onChange }: SearchFilterProps) => {
        const handleChange = (e: ChangeEvent<HTMLInputElement>): void =>
            onChange('q', e.target.value);

        const value = query === null ? '' : query;
        return (
            <div className='col-2'>
                <GenericComponentWrapper value={query} name='search' label='Search'>
                    <input type='text' value={value} onChange={handleChange} />
                </GenericComponentWrapper>
            </div>
        );
    }
);
